<template>
  <input type="checkbox" id="toggle-mode-cb" onchange="changeMode()" />
  <div id="change_mode">
    <div class="AZ-page">
      <!-- navbar -->
      <header class="AZ-navbar">
        <nav class="navbar navbar-expand-lg d-flex flex-column p-0">
          <div class="container">
            <div
              class="collapse navbar-collapse d-flex align-items-center justify-content-between"
              id="navbarSupportedContent"
            >
              <a
                href="#"
                class="nav-btn"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
                ><span class="icon-search-normal"></span
              ></a>

              <a class="navbar-brand d-block" href="#"
                ><img src="/assets/img/logo.png" alt=""
              /></a>

              <ProfileDropdown :username="username" @logout="handleLogout" />
            </div>
          </div>
        </nav>
      </header>
      <!-- navbar bottom -->
      <BottomNavbar activeTab="staking" />
      <!-- breadcrumbs -->
      <section class="AZ-breadcrumbs-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div
                class="d-flex align-items-center justify-content-between gap-3"
              >
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item">
                      <a href="#">سپرده گذاری</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      {{ currentStep === 1 ? 'شروع سپرده گذاری' : currentStep === 2 ? 'تکمیل اطلاعات' : 'تایید نهایی' }}
                    </li>
                  </ol>
                </nav>
                <a href="#" class="back-btn d-flex align-items-center gap-1" @click.prevent="handleBack">
                  <span class="icon-arrow_back"></span
                ></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Step 1: Display conditions and calculate interest -->
      <template v-if="currentStep === 1">
        <!-- slider -->
        <BannerSlider 
          type="main_slider"
          :show-fallback="true"
          fallback-title="دریافت تسهیلات"
          fallback-description="500 میلیون تومان وام بگیر با امتیاز"
        />
        <!-- banner -->
        <section class="AZ-banner-section AZ-banner--staking-section">
          <div class="container">
            <div class="row">
              <div class="col-lg-12 mb-3" v-if="periodInfo">
                <a href="#" class="banner-box AZ-img-container">
                  <div class="AZ-img-container-inner AZ-img-cover">
                    <img src="/img/sod seporde.png" alt="سود سپرده دوره قبلی" />
                  </div>
                  <div class="banner-content d-flex align-items-center gap-2">
                    <div class="w-100">
                      <h4 class="banner-title mb-2">سود سپرده دوره قبلی</h4>
                      <p class="banner-desc mb-2">سود کسب‌شده کاربران در دوره قبل</p>
                      <p class="price d-flex align-items-center gap-1 mb-2">
                        <span class="prices">{{ formatNumber(periodInfo.previous_period_profit || 0) }}</span> تتر
                      </p>
                      <div class="d-flex align-items-center gap-2">
                        <time
                          class="countdown amazing-offer-time timer-light d-flex"
                          :date-time="periodInfo.next_period_start"
                        ></time>
                        <p class="banner-text">تا شروع دوره بعدی</p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col-lg-12 mb-3" v-if="lastDeposit">
                <a href="#" class="banner-box AZ-img-container">
                  <div class="AZ-img-container-inner AZ-img-cover">
                    <img src="/assets/img/banner2.png" alt="" />
                  </div>
                  <div class="banner-content d-flex align-items-center gap-2">
                    <div class="w-100">
                      <h4 class="banner-title mb-2">سود</h4>
                      <ul class="banner-list w-100">
                        <li
                          class="d-flex align-items-center gap-2 justify-content-between py-1"
                        >
                          <p class="banner-list--title">
                            تاریخ سپرده گذاری اخیر
                          </p>
                          <p class="banner-list--title">{{ formatDate(lastDeposit.start_date) }}</p>
                        </li>
                        <li
                          class="d-flex align-items-center gap-2 justify-content-between py-1"
                        >
                          <p class="banner-list--title">مبلغ سپرده گذاری</p>
                          <p
                            class="banner-list--price d-flex align-items-center gap-1"
                          >
                            <span class="price">{{ formatNumber(lastDeposit.amount) }}</span> تتر
                          </p>
                        </li>
                        <li
                          class="d-flex align-items-center gap-2 justify-content-between py-1"
                        >
                          <p class="banner-list--title">سود کسب شده</p>
                          <p
                            class="banner-list--price d-flex align-items-center gap-1"
                          >
                            <span class="price">{{ formatNumber(lastDeposit.paid_interest || 0) }}</span> تتر
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row" v-if="pendingDeposit">
              <div class="col-lg-12">
                <a
                  href="#"
                  class="banner-box banner-box-timer AZ-img-container"
                >
                  <div class="AZ-img-container-inner AZ-img-cover">
                    <img src="/assets/img/banner3.png" alt="" />
                  </div>
                  <div class="banner-content d-flex align-items-center gap-2">
                    <div class="d-flex align-items-center gap-2">
                      <!-- timer -->
                      <time
                        class="countdown amazing-offer-time timer-light d-flex"
                        :date-time="pendingDeposit.end_date"
                      ></time>
                      <p class="banner-text">تا فعال شدن سپرده گذاری</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <!-- staking -->
        <section class="AZ-staking-page staking-step-overview">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2 class="AZ-section-title mb-3">شرایط سپرده گذاری</h2>
              </div>
              <div class="col-lg-12">
                <div class="AZ-box" v-if="settings">
                  <ul class="box--list" v-if="settings.landing_terms_text">
                    <li v-for="(line, index) in settings.landing_terms_text.split('\n')" :key="index">
                      {{ line }}
                    </li>
                  </ul>
                </div>
                <div
                  class="AZ-box d-flex align-items-center justify-content-between gap-3"
                >
                  <div class="flex-grow-1">
                    <h4 class="box--title">نرخ سود</h4>
                    <p class="box--text" v-if="settings">
                      نرخ سود سالانه: {{ settings.interest_rate }}% {{ settings.is_fixed_rate ? 'ثابت' : 'متغیر' }}
                    </p>
                    <p class="box--text" v-if="settings && settings.period_interest_rate">
                      نرخ سود هر دوره (۱۴ روز): {{ settings.period_interest_rate }}%
                    </p>
                  </div>
                  <img src="/assets/img/Capa_1.png" alt="" width="95" />
                </div>
              </div>
              <div class="col-lg-12 staking-calculator-col">
                <div
                  class="loan-calculator d-flex flex-column align-items-center justify-content-center gap-3"
                >
                  <span class="range-slider__subtitle">سود سپرده</span>
                  <p
                    class="range-slider__title d-flex align-items-center justify-content-center gap-1"
                  >
                    <span class="prices">{{ formatNumber(calculatedInterest.total_interest || 0) }}</span> تتر
                  </p>
                  <span class="range-slider__subtitle text-start w-100"
                    >مبلغ ورودی</span
                  >
                  <div class="range-slider w-100">
                    <div
                      class="range-slider__slider d-flex align-items-center justify-content-between gap-1 w-100"
                    >
                      <p
                        class="range-slider__value d-flex align-items-center gap-1"
                      >
                        تتر
                        <span class="min">{{ formatNumber(minAmount) }}</span>
                      </p>
                      <input
                        type="range"
                        :min="minAmount"
                        :max="maxAmount"
                        :value="formData.amount"
                        class="slider flex-grow-1"
                        id="amountSlider"
                        @input="updateAmount"
                      />
                      <p
                        class="range-slider__value d-flex align-items-center gap-1"
                      >
                        تتر
                        <span class="max prices">{{ formatNumber(maxAmount) }}</span>
                      </p>
                    </div>
                    <p class="range-slider__value text-center mt-2">
                      تتر
                      <span class="number prices">{{ formatNumber(formData.amount) }}</span>
                    </p>
                  </div>

                  <span class="range-slider__subtitle text-start w-100">
                    تعداد دوره
                  </span>
                  <div class="range-slider w-100">
                    <div
                      class="range-slider__slider d-flex align-items-center justify-content-between gap-1 w-100"
                    >
                      <p
                        class="range-slider__value d-flex align-items-center gap-1"
                      >
                        <span class="min">{{ minPeriods }} دوره</span>
                      </p>
                      <input
                        type="range"
                        :min="minPeriods"
                        :max="maxPeriods"
                        :value="formData.periods"
                        :step="1"
                        class="slider flex-grow-1 slider-duration"
                        id="durationSlider"
                        @input="updatePeriods"
                      />
                      <p
                        class="range-slider__value d-flex align-items-center gap-1"
                      >
                        <span class="max">{{ maxPeriods }} دوره</span>
                      </p>
                    </div>
                    <p
                      class="range-slider__value text-center d-flex align-items-center gap-1 flex-row-reverse mt-2"
                    >
                      <span class="number d-flex align-items-center">{{ formData.periods }} دوره</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-6 staking-promo-col">
                <PromoBanner 
                  type="staking_start_banner"
                  section-class="staking-small-banner-section"
                  row-class="g-0"
                  col-class="col-12 p-0"
                  banner-class="staking-small-banner"
                  :show-fallback="true"
                  fallback-image="/assets/img/staking-banner1.png"
                  :click-only="true"
                  @banner-click="goToStep(2)"
                />
              </div>
              <div class="col-6 staking-promo-col">
                <PromoBanner 
                  type="staking_my_deposits_banner"
                  section-class="staking-small-banner-section"
                  row-class="g-0"
                  col-class="col-12 p-0"
                  banner-class="staking-small-banner banner-dark"
                  :show-fallback="true"
                  fallback-image="/assets/img/staking-banner2.png"
                  fallback-link="/my-stakes"
                  :click-only="true"
                  @banner-click="$router.push('/my-stakes')"
                />
              </div>
            </div>
          </div>
        </section>
      </template>

      <!-- Step 2: Complete deposit form -->
      <template v-if="currentStep === 2">
        <section class="AZ-staking-page">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <h2 class="AZ-section-title mb-3">شرایط سپرده گذاری</h2>
              </div>
              <div class="col-lg-12">
                <div class="AZ-box" v-if="settings">
                  <h4 class="box--title">نحوه عملکرد طرح سپرده گذاری</h4>
                  <ul class="box--list" v-if="settings.start_how_it_works_text">
                    <li v-for="(line, index) in settings.start_how_it_works_text.split('\n')" :key="index">
                      {{ line }}
                    </li>
                  </ul>
                </div>
                <div
                  class="AZ-box d-flex align-items-center justify-content-between gap-3"
                >
                  <div class="flex-grow-1">
                    <h4 class="box--title">نرخ سود</h4>
                    <p class="box--text" v-if="settings">
                      نرخ سود سالانه: {{ settings.interest_rate }}% {{ settings.is_fixed_rate ? 'ثابت' : 'متغیر' }}
                    </p>
                    <p class="box--text" v-if="settings && settings.period_interest_rate">
                      نرخ سود هر دوره (۱۴ روز): {{ settings.period_interest_rate }}%
                    </p>
                  </div>
                  <img src="/assets/img/Capa_1.png" alt="" width="95" />
                </div>
                <div class="AZ-box">
                  <div class="flex-grow-1">
                    <h4 class="box--title">خلاصه قوانین و مقررات</h4>
                    <ul class="box--list" v-if="settings && settings.start_rules_summary_text">
                      <li v-for="(line, index) in settings.start_rules_summary_text.split('\n')" :key="index">
                        {{ line }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="deposit-amount-box">
                  <h4 class="AZ-section-title mb-2">مبلغ سپرده گذاری</h4>
                  
                  <!-- Wallet Selection -->
                  <div class="AZ-field-group mb-3">
                    <label>انتخاب کیف پول</label>
                    <div class="field-inner">
                      <select 
                        v-model="formData.walletType" 
                        @change="onWalletChange"
                        class="form-select"
                        :disabled="usdtWallets.length === 0"
                      >
                        <option v-if="walletsLoading" value="">
                          در حال بارگذاری کیف پول‌ها...
                        </option>
                        <option v-else-if="usdtWallets.length === 0" value="">
                          کیف پول تتر در دسترس نیست
                        </option>
                        <option 
                          v-for="wallet in usdtWallets" 
                          :key="wallet.id"
                          :value="wallet.slug"
                        >
                          {{ wallet.name }} - موجودی: {{ wallet.formatted_balance }} تتر
                        </option>
                      </select>
                    </div>
                    <small v-if="walletLoadError" class="text-danger">
                      {{ walletLoadError }}
                      <button type="button" class="btn btn-link p-0" @click="fetchWallets">تلاش مجدد</button>
                    </small>
                  </div>
                  
                  <ul>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title">موجودی کیف پول</p>
                      <p class="list-price d-flex align-items-center gap-1">
                        <span class="prices">{{ selectedWallet ? formatNumber(selectedWallet.balance) : '0' }}</span>تتر
                      </p>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title">حداقل مبلغ سرمایه گذاری</p>
                      <p class="list-price d-flex align-items-center gap-1">
                        <span class="prices">{{ formatNumber(minAmount) }}</span>تتر
                      </p>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title">حداکثر مبلغ سرمایه گذاری</p>
                      <p class="list-price d-flex align-items-center gap-1">
                        <span class="prices">{{ formatNumber(maxAmount) }}</span>تتر
                      </p>
                    </li>
                  </ul>
                  <div class="AZ-field-group">
                    <label>مبلغ سپرده گذاری</label>
                    <div class="field-inner">
                      <input
                        type="number"
                        v-model.number="formData.amount"
                        :min="minAmount"
                        :max="maxAmount"
                        placeholder="لطفا مبلغ دلخواه سپرده گذاری رو وارد کنید."
                        @input="handleAmountInput"
                      />
                    </div>
                    <small v-if="amountError" class="text-danger">{{ amountError }}</small>
                  </div>
                  <div class="AZ-field-group mt-3">
                    <label>تعداد دوره‌ها</label>
                    <div class="field-inner">
                      <input
                        type="number"
                        v-model.number="formData.periods"
                        :min="minPeriods"
                        :max="maxPeriods"
                        :step="1"
                        placeholder="تعداد دوره‌ها را وارد کنید"
                        @input="handlePeriodsInput"
                      />
                    </div>
                    <small v-if="periodsError" class="text-danger">{{ periodsError }}</small>
                  </div>
                  <ul>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title monthly-profit-amount">
                        مبلغ سود دوره‌ای پس از سرمایه گذاری
                      </p>
                      <p
                        class="list-price monthly-profit-amount d-flex align-items-center gap-1"
                      >
                        <span class="prices">{{ formatNumber(calculatedInterest.period_interest || 0) }}</span>تتر
                      </p>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title">
                        سود کل
                      </p>
                      <p
                        class="list-price d-flex align-items-center gap-1"
                      >
                        <span class="prices">{{ formatNumber(calculatedInterest.total_interest || 0) }}</span>تتر
                      </p>
                    </li>
                    <li
                      class="d-flex align-items-center justify-content-between gap-2 py-1"
                    >
                      <p class="list-title">
                        مبلغ نهایی
                      </p>
                      <p
                        class="list-price d-flex align-items-center gap-1"
                      >
                        <span class="prices">{{ formatNumber(calculatedInterest.final_amount || 0) }}</span>تتر
                      </p>
                    </li>
                  </ul>
                </div>
                <div
                  class="d-flex align-items-center justify-content-center mt-4"
                >
                  <button
                    @click="goToStep(3)"
                    :disabled="!canProceedToStep3"
                    class="AZ-primary-btn d-flex align-items-center justify-content-center gap-4"
                  >
                  <span class="icon-arrow-right"></span
                    >
                    تایید و ادامه
                   </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>

      <!-- Step 3: Final confirmation -->
      <template v-if="currentStep === 3">
        <section class="AZ-staking-page">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="AZ-box">
                  <h4 class="box--title">قوانین و قرارداد</h4>
                  <ul class="box--list deposit-contract-scroll" v-if="settings && (settings.final_contract_text || settings.terms_and_conditions)">
                    <li v-for="(line, index) in (settings.final_contract_text || settings.terms_and_conditions).split('\n')" :key="index">
                      {{ line }}
                    </li>
                  </ul>
                  <div
                    class="download-box d-flex align-items-center justify-content-between gap-3 mt-3"
                    v-if="contractPdfUrl"
                  >
                    <p class="file-name d-flex align-items-center gap-2">
                      <span class="icon-document"></span> قرارداد.pdf
                    </p>
                    <a
                      :href="contractPdfUrl"
                      target="_blank"
                      download
                      class="download-btn d-flex align-items-center gap-3"
                    >
                      دانلود <span class="icon-receive-square"></span
                    ></a>
                  </div>
                </div>
                <div class="AZ-checkbox-group">
                  <input type="checkbox" id="ruls" v-model="acceptedTerms" />
                  <label for="ruls">
                    قوانین و مقررات را مطالعه کرده و شرایط را می پذیرم.
                  </label>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <button
                    @click="openSecurityCanvas"
                    :disabled="!acceptedTerms"
                    class="AZ-primary-btn d-flex align-items-center justify-content-center gap-4 mt-4"
                  >
                    ایجاد طرح سپرده گذاری
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </div>

    <!-- Security Canvas - Password -->
    <div
      class="offcanvas offcanvas-bottom canvas-wrapper"
      tabindex="-1"
      id="passwordCanvas"
      aria-labelledby="offcanvasBottomLabel"
      ref="passwordCanvas"
    >
      <div class="offcanvas-header">
        <div
          class="table-container d-flex align-items-center justify-content-between w-100"
        >
          <a
            href="#"
            class="tab-link active d-flex align-items-center gap-1 justify-content-center flex-grow-1"
            @click.prevent="switchToPasswordTab"
          >
            رمز عبور
          </a>
          <a
            href="#"
            class="tab-link d-flex align-items-center gap-1 justify-content-center flex-grow-1"
            @click.prevent="switchToEmailTab"
          >
            ایمیل
          </a>
        </div>
      </div>
      <div class="offcanvas-body small">
        <div>
          <p class="canvas-text text-center">
            برای انجام سپرده گذاری لطفا رمز عبور تایید خود را وارد کنید.
          </p>
          <div class="AZ-field-group">
            <label for="">رمز عبور تایید</label>
            <div class="field-inner">
              <input
                type="password"
                id="password-field"
                v-model="securityForm.password"
                placeholder="رمز عبور تایید را وارد کنید."
                ref="passwordInput"
              />
              <span
                @click="togglePasswordVisibility('password-field')"
                class="toggle-password icon-eye-off"
              ></span>
            </div>
          </div>
          <div
            class="d-flex flex-column gap-2 justify-content-center align-items-center mt-4"
          >
            <button
              @click="confirmWithPassword"
              :disabled="processing"
              class="AZ-primary-btn d-flex align-items-center justify-content-center"
            >
              {{ processing ? 'در حال پردازش...' : 'ثبت و ادامه' }}
            </button>
            <router-link
              to="/recover-key"
              class="forget-pass d-flex align-items-center gap-1 justify-content-center"
            >
              فراموشی کلید
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Security Canvas - Email -->
    <div
      class="offcanvas offcanvas-bottom canvas-wrapper"
      tabindex="-1"
      id="emailCanvas"
      aria-labelledby="offcanvasBottomLabel"
      ref="emailCanvas"
    >
      <div class="offcanvas-header">
        <div
          class="table-container d-flex align-items-center justify-content-between w-100"
        >
          <a
            href="#"
            class="tab-link d-flex align-items-center gap-1 justify-content-center flex-grow-1"
            @click.prevent="switchToPasswordTab"
          >
            رمز عبور
          </a>
          <a
            href="#"
            class="tab-link active d-flex align-items-center gap-1 justify-content-center flex-grow-1"
            @click.prevent="switchToEmailTab"
          >
            ایمیل
          </a>
        </div>
      </div>
      <div class="offcanvas-body small">
        <div>
          <p class="canvas-text text-center">
            برای انجام سپرده گذاری لطفا ایمیل خود را وارد کنید و سپس رمز ارسال
            شده را وارد کنید.
          </p>
          <div class="AZ-field-group">
            <label for=""> ایمیل </label>
            <div class="field-inner">
              <input type="email" v-model="securityForm.email" />
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <button
              @click="sendOTP"
              :disabled="processing || !securityForm.email"
              class="AZ-primary-btn d-flex align-items-center justify-content-center"
            >
              {{ processing ? 'در حال ارسال...' : 'ارسال کد' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Security Canvas - OTP -->
    <div
      class="offcanvas offcanvas-bottom canvas-wrapper"
      tabindex="-1"
      id="otpCanvas"
      aria-labelledby="offcanvasBottomLabel"
      ref="otpCanvas"
    >
      <div class="offcanvas-header">
        <div
          class="table-container d-flex align-items-center justify-content-between w-100"
        >
          <a
            href="#"
            class="tab-link d-flex align-items-center gap-1 justify-content-center flex-grow-1"
            @click.prevent="switchToPasswordTab"
          >
            رمز عبور
          </a>
          <a
            href="#"
            class="tab-link active d-flex align-items-center gap-1 justify-content-center flex-grow-1"
          >
            ایمیل
          </a>
        </div>
      </div>
      <div class="offcanvas-body small">
        <div>
          <p class="canvas-text text-center">
            برای انجام سپرده گذاری لطفا رمز ارسال شده به ایمیل را وارد کنید.
          </p>
          <div class="AZ-field-group">
            <label for=""> رمز </label>
            <div class="field-inner">
              <input
                type="text"
                id="otp-field"
                v-model="securityForm.otp"
                placeholder="رمز ارسال شده به ایمیل را وارد کنید."
                maxlength="6"
              />
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center mt-4">
            <button
              @click="confirmWithOTP"
              :disabled="processing || !securityForm.otp"
              class="AZ-primary-btn d-flex align-items-center justify-content-center"
            >
              {{ processing ? 'در حال پردازش...' : 'ثبت' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BottomNavbar from '@/components/BottomNavbar.vue'
import ProfileDropdown from '@/components/ProfileDropdown.vue'
import BannerSlider from '@/components/BannerSlider.vue'
import PromoBanner from '@/components/PromoBanner.vue'
import { getDepositSettings, getPeriodInfo, createDeposit, confirmDeposit, getMyDeposits } from '@/api/depositPlans'
import { authAPI, walletAPI } from '@/api'
import { useAlert } from '@/composables/useAlert'

export default {
  name: 'StakingPage',
  components: {
    BottomNavbar,
    ProfileDropdown,
    BannerSlider,
    PromoBanner
  },
  data() {
    return {
      username: '',
      currentStep: 1,
      settings: null,
      loading: false,
      processing: false,
      acceptedTerms: false,
      formData: {
        amount: 1000,
        periods: 2, // شروع با ۲ دوره (۲۸ روز)
        walletType: 'usdt-main'
      },
      wallets: [],
      walletsLoading: true,
      walletLoadError: '',
      selectedWallet: null,
      calculatedInterest: {},
      periodInfo: null,
      lastDeposit: null,
      pendingDeposit: null,
      securityForm: {
        password: '',
        email: '',
        otp: ''
      },
      securityTab: 'password', // 'password' or 'email'
      createdDepositId: null,
      amountError: '',
      periodsError: ''
    }
  },
  computed: {
    minAmount() {
      return this.settings ? parseFloat(this.settings.min_amount) : 100
    },
    maxAmount() {
      return this.settings ? parseFloat(this.settings.max_amount) : 1000000
    },
    minPeriods() {
      const daysPerPeriod = this.settings?.period_duration_days || 14
      return this.settings ? Math.ceil(parseInt(this.settings.min_duration_days) / daysPerPeriod) : 1
    },
    maxPeriods() {
      const daysPerPeriod = this.settings?.period_duration_days || 14
      return this.settings ? Math.floor(parseInt(this.settings.max_duration_days) / daysPerPeriod) : 26
    },
    minDurationDays() {
      return this.settings ? parseInt(this.settings.min_duration_days) : 14
    },
    maxDurationDays() {
      return this.settings ? parseInt(this.settings.max_duration_days) : 364
    },
    canProceedToStep3() {
      return Boolean(this.settings) &&
             Boolean(this.selectedWallet) &&
             this.formData.amount >= this.minAmount &&
             this.formData.amount <= this.maxAmount &&
             this.formData.periods >= this.minPeriods &&
             this.formData.periods <= this.maxPeriods &&
             !this.amountError &&
             !this.periodsError
    },
    usdtWallets() {
      if (!Array.isArray(this.wallets)) {
        return []
      }
      return this.wallets.filter(w => w.slug === 'usdt-main')
    },
    contractPdfUrl() {
      const contractUrl = this.settings?.contract_pdf_url || this.settings?.contract_pdf_path
      if (!contractUrl) return null

      if (/^https?:\/\//i.test(contractUrl)) return contractUrl

      const storagePath = contractUrl.replace(/^\/?storage\/?/, '')
      const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || ''
      const apiOrigin = apiBaseUrl.replace(/\/api\/?$/, '').replace(/\/$/, '')

      return `${apiOrigin}/storage/${storagePath}`
    }
  },
  mounted() {
    this.fetchSettings()
    this.fetchPeriodInfo()
    this.fetchLastDeposit()
    this.fetchWallets()
    this.initializeSliders()
  },
  methods: {
    async fetchSettings() {
      this.loading = true
      try {
        const response = await getDepositSettings()
        if (response.data.message && response.data.data) {
          this.settings = response.data.data.settings
          // Set initial form values based on settings
          if (this.settings) {
            this.formData.amount = Math.max(this.minAmount, 1000)
            this.formData.periods = Math.max(this.minPeriods, 2) // حداقل ۲ دوره
            this.calculateInterestAmount()
          }
        }
      } catch (error) {
        console.error('Error fetching settings:', error)
        useAlert().showError(error.response?.data?.message || 'خطا در دریافت تنظیمات')
      } finally {
        this.loading = false
      }
    },
    async fetchPeriodInfo() {
      try {
        const response = await getPeriodInfo()
        if (response.data.data) {
          this.periodInfo = response.data.data
        }
      } catch (error) {
        console.error('Error fetching period info:', error)
      }
    },
    async fetchLastDeposit() {
      try {
        const response = await getMyDeposits('active', 15, 1)
        if (response.data.data && response.data.data.data && response.data.data.data.length > 0) {
          this.lastDeposit = response.data.data.data[0]
        }
        // Also check for pending deposits
        const pendingResponse = await getMyDeposits('pending', 15, 1)
        if (pendingResponse.data.data && pendingResponse.data.data.data && pendingResponse.data.data.data.length > 0) {
          this.pendingDeposit = pendingResponse.data.data.data[0]
        }
      } catch (error) {
        console.error('Error fetching deposits:', error)
      }
    },
    async fetchWallets() {
      this.walletsLoading = true
      this.walletLoadError = ''
      try {
        const response = await walletAPI.getAll()
        
        // Extract wallets from new structure
        // Response format: { data: { BTC: { wallets: [] }, USDT: { wallets: [] } } }
        const walletsData = response?.data?.data
        
        if (walletsData) {
          // Flatten all wallets from all cryptocurrencies into a single array
          const allWallets = []
          
          // Iterate through each cryptocurrency (BTC, USDT, etc.)
          Object.keys(walletsData).forEach(cryptoSymbol => {
            const cryptoData = walletsData[cryptoSymbol]
            if (cryptoData.wallets && Array.isArray(cryptoData.wallets)) {
              cryptoData.wallets.forEach(wallet => {
                // Add cryptocurrency info to wallet for reference
                allWallets.push({
                  ...wallet,
                  cryptocurrency: cryptoData.cryptocurrency,
                  crypto_symbol: cryptoSymbol,
                  // Map slug to wallet_type for consistency
                  wallet_type: wallet.slug
                })
              })
            }
          })
          
          this.wallets = allWallets
          
          // Deposits always use the single main USDT wallet.
          const usdtWallets = this.wallets.filter(w => w.slug === 'usdt-main')
          if (usdtWallets.length > 0) {
            this.selectedWallet = usdtWallets[0]
            this.formData.walletType = this.selectedWallet.slug
          } else {
            this.selectedWallet = null
            this.formData.walletType = ''
            this.walletLoadError = 'کیف پول تتر برای حساب شما آماده نشده است.'
          }
        } else {
          this.wallets = []
          this.selectedWallet = null
          this.formData.walletType = ''
          this.walletLoadError = 'اطلاعات کیف پول دریافت نشد.'
        }
      } catch (error) {
        console.error('Error fetching wallets:', error)
        this.wallets = []
        this.selectedWallet = null
        this.formData.walletType = ''
        this.walletLoadError = error.response?.data?.message || 'خطا در دریافت کیف پول‌ها.'
      } finally {
        this.walletsLoading = false
      }
    },
    onWalletChange() {
      this.selectedWallet = this.wallets.find(w => w.slug === this.formData.walletType)
      this.validateAmount()
    },
    updateAmount(event) {
      this.formData.amount = parseFloat(event.target.value)
      this.validateAmount()
      this.calculateInterestAmount()
    },
    updatePeriods(event) {
      this.formData.periods = parseInt(event.target.value)
      this.validatePeriods()
      this.calculateInterestAmount()
    },
    handleAmountInput() {
      this.validateAmount()
      this.calculateInterestAmount()
    },
    handlePeriodsInput() {
      this.validatePeriods()
      this.calculateInterestAmount()
    },
    validateAmount() {
      if (this.formData.amount < this.minAmount) {
        this.amountError = `مبلغ باید حداقل ${this.formatNumber(this.minAmount)} تتر باشد`
      } else if (this.formData.amount > this.maxAmount) {
        this.amountError = `مبلغ باید حداکثر ${this.formatNumber(this.maxAmount)} تتر باشد`
      } else if (this.selectedWallet && parseFloat(this.formData.amount) > parseFloat(this.selectedWallet.balance)) {
        this.amountError = `موجودی کیف پول کافی نیست. موجودی فعلی: ${this.formatNumber(this.selectedWallet.balance)} تتر`
      } else {
        this.amountError = ''
      }
    },
    validatePeriods() {
      if (this.formData.periods < this.minPeriods) {
        this.periodsError = `تعداد دوره‌ها باید حداقل ${this.minPeriods} دوره باشد`
      } else if (this.formData.periods > this.maxPeriods) {
        this.periodsError = `تعداد دوره‌ها باید حداکثر ${this.maxPeriods} دوره باشد`
      } else {
        this.periodsError = ''
      }
    },
    calculateInterestAmount() {
      if (!this.formData.amount || !this.formData.periods || !this.settings) return

      const amount = parseFloat(this.formData.amount)
      const periods = parseInt(this.formData.periods)
      const daysPerPeriod = this.settings.period_duration_days || 14

      // اگر تنظیمات سود دوره‌ای وجود دارد از آن استفاده کنیم، در غیر اینصورت از نرخ سود سالانه
      let interestPerPeriod = 0
      if (this.settings.period_interest_rate) {
        // سود هر دوره به صورت مستقیم تعریف شده
        interestPerPeriod = parseFloat(this.settings.period_interest_rate) / 100
      } else {
        // محاسبه سود دوره‌ای بر اساس نرخ سود سالانه
        const annualInterestRate = parseFloat(this.settings.interest_rate) / 100
        const periodInterestRate = annualInterestRate * (daysPerPeriod / 365)
        interestPerPeriod = periodInterestRate
      }

      // محاسبه سود کل: مبلغ × نرخ سود دوره × تعداد دوره‌ها
      const totalInterest = amount * interestPerPeriod * periods

      // محاسبه سود ماهانه (تقریباً ۲ دوره)
      const monthlyInterest = (totalInterest / periods) * 2

      // مبلغ نهایی = مبلغ اصلی + سود کل
      const finalAmount = amount + totalInterest

      this.calculatedInterest = {
        total_interest: totalInterest.toFixed(2),
        monthly_interest: monthlyInterest.toFixed(2),
        final_amount: finalAmount.toFixed(2),
        period_interest: (interestPerPeriod * amount).toFixed(2),
        total_periods: periods,
        days_per_period: daysPerPeriod
      }
    },
    goToStep(step) {
      if (step === 2) {
        if (!this.settings) {
          useAlert().showError('تنظیمات سپرده‌گذاری هنوز دریافت نشده است. لطفاً دوباره تلاش کنید.')
          return
        }

        const amount = parseFloat(this.formData.amount)
        const periods = parseInt(this.formData.periods)
        const amountIsValid = Number.isFinite(amount) && amount >= this.minAmount && amount <= this.maxAmount
        const periodsAreValid = Number.isInteger(periods) && periods >= this.minPeriods && periods <= this.maxPeriods

        if (!amountIsValid) {
          this.validateAmount()
          useAlert().showError(this.amountError || 'مبلغ سپرده معتبر نیست.')
          return
        }

        if (!periodsAreValid) {
          this.validatePeriods()
          useAlert().showError(this.periodsError || 'تعداد دوره معتبر نیست.')
          return
        }

        // Wallet availability and balance are shown and validated in the form.
        // They must not make the start banner look unresponsive.
        this.currentStep = step
        this.validateAmount()
        this.calculateInterestAmount()
      } else if (step === 3) {
        if (this.canProceedToStep3) {
          this.currentStep = step
        }
      } else {
        this.currentStep = step
      }
    },
    handleBack() {
      if (this.currentStep > 1) {
        this.currentStep--
      } else {
        this.$router.push('/')
      }
    },
    openSecurityCanvas() {
      if (!this.acceptedTerms) {
        useAlert().showWarning('لطفا قوانین و مقررات را بپذیرید')
        return
      }
      this.securityTab = 'password'
      // Use Bootstrap's data-bs-toggle instead
      const canvasElement = this.$refs.passwordCanvas
      if (canvasElement) {
        const bsOffcanvas = window.bootstrap?.Offcanvas || null
        if (bsOffcanvas) {
          const canvas = new bsOffcanvas(canvasElement)
          canvas.show()
        }
      }
    },
    switchToPasswordTab() {
      const passwordCanvasEl = this.$refs.passwordCanvas
      const emailCanvasEl = this.$refs.emailCanvas
      const otpCanvasEl = this.$refs.otpCanvas
      const bsOffcanvas = window.bootstrap?.Offcanvas || null
      
      if (bsOffcanvas) {
        if (emailCanvasEl) {
          const emailCanvas = bsOffcanvas.getInstance(emailCanvasEl)
          if (emailCanvas) emailCanvas.hide()
        }
        if (otpCanvasEl) {
          const otpCanvas = bsOffcanvas.getInstance(otpCanvasEl)
          if (otpCanvas) otpCanvas.hide()
        }
        if (passwordCanvasEl) {
          const passwordCanvas = bsOffcanvas.getOrCreateInstance(passwordCanvasEl)
          passwordCanvas.show()
        }
      }
      this.securityTab = 'password'
    },
    switchToEmailTab() {
      const emailCanvasEl = this.$refs.emailCanvas
      const passwordCanvasEl = this.$refs.passwordCanvas
      const bsOffcanvas = window.bootstrap?.Offcanvas || null
      
      if (bsOffcanvas) {
        if (passwordCanvasEl) {
          const passwordCanvas = bsOffcanvas.getInstance(passwordCanvasEl)
          if (passwordCanvas) passwordCanvas.hide()
        }
        if (emailCanvasEl) {
          const emailCanvas = bsOffcanvas.getOrCreateInstance(emailCanvasEl)
          emailCanvas.show()
        }
      }
      this.securityTab = 'email'
    },
    async sendOTP() {
      if (!this.securityForm.email) {
        useAlert().showWarning('لطفا ایمیل خود را وارد کنید')
        return
      }
      
      this.processing = true
      try {
        await authAPI.sendOTP(this.securityForm.email)
        useAlert().showSuccess('کد تایید به ایمیل شما ارسال شد')
        // Switch to OTP canvas
        const otpCanvasEl = this.$refs.otpCanvas
        const emailCanvasEl = this.$refs.emailCanvas
        const bsOffcanvas = window.bootstrap?.Offcanvas || null
        
        if (bsOffcanvas) {
          if (emailCanvasEl) {
            const emailCanvas = bsOffcanvas.getInstance(emailCanvasEl)
            if (emailCanvas) emailCanvas.hide()
          }
          if (otpCanvasEl) {
            const otpCanvas = bsOffcanvas.getOrCreateInstance(otpCanvasEl)
            otpCanvas.show()
          }
        }
      } catch (error) {
        useAlert().showError(error.response?.data?.message || 'خطا در ارسال کد تایید')
      } finally {
        this.processing = false
      }
    },
    async confirmWithPassword() {
      if (!this.securityForm.password) {
        useAlert().showWarning('لطفا رمز عبور تایید را وارد کنید')
        return
      }
      
      await this.createAndConfirmDeposit(this.securityForm.password)
    },
    async confirmWithOTP() {
      if (!this.securityForm.otp) {
        useAlert().showWarning('لطفا کد تایید را وارد کنید')
        return
      }
      
      await this.createAndConfirmDeposit(this.securityForm.otp)
    },
    async createAndConfirmDeposit(securityCode) {
      this.processing = true
      const alert = useAlert()
      
      try {
        // First create the deposit - convert periods to total days
        const daysPerPeriod = this.settings?.period_duration_days || 14
        const totalDays = this.formData.periods * daysPerPeriod
        const createResponse = await createDeposit(this.formData.walletType, this.formData.amount, totalDays)
        
        if (createResponse.data.data && createResponse.data.data.deposit) {
          this.createdDepositId = createResponse.data.data.deposit.id
          
          // Then confirm it
          const confirmResponse = await confirmDeposit(this.createdDepositId, securityCode)
          
          if (confirmResponse.data.data) {
            // Close all canvases
            const bsOffcanvas = window.bootstrap?.Offcanvas || null
            if (bsOffcanvas) {
              const passwordCanvasEl = this.$refs.passwordCanvas
              const emailCanvasEl = this.$refs.emailCanvas
              const otpCanvasEl = this.$refs.otpCanvas
              
              if (passwordCanvasEl) {
                const passwordCanvas = bsOffcanvas.getInstance(passwordCanvasEl)
                if (passwordCanvas) passwordCanvas.hide()
              }
              if (emailCanvasEl) {
                const emailCanvas = bsOffcanvas.getInstance(emailCanvasEl)
                if (emailCanvas) emailCanvas.hide()
              }
              if (otpCanvasEl) {
                const otpCanvas = bsOffcanvas.getInstance(otpCanvasEl)
                if (otpCanvas) otpCanvas.hide()
              }
            }
            
            await alert.showSuccess('سپرده گذاری با موفقیت انجام شد')
            this.$router.push('/my-stakes')
          }
        }
      } catch (error) {
        console.error('Error creating/confirming deposit:', error)
        const msg = error.response?.data?.message || error.response?.data?.error || 'خطا در ایجاد سپرده گذاری'
        alert.showError(msg)
        if (msg.includes('رمز عبور تایید') || msg.includes('امنیت پروفایل')) {
          this.$router.push('/profile/security')
        }
      } finally {
        this.processing = false
      }
    },
    togglePasswordVisibility(fieldId) {
      const field = document.getElementById(fieldId)
      const toggle = field.nextElementSibling
      if (field.type === 'password') {
        field.type = 'text'
        toggle.classList.remove('icon-eye-off')
        toggle.classList.add('icon-eye')
      } else {
        field.type = 'password'
        toggle.classList.remove('icon-eye')
        toggle.classList.add('icon-eye-off')
      }
    },
    formatNumber(num) {
      if (!num) return '0'
      return new Intl.NumberFormat('fa-IR').format(num)
    },
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat('fa-IR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).format(date)
      } catch (e) {
        return dateString
      }
    },
    handleLogout() {
      this.$router.push('/login')
    },
    initializeSliders() {
      // Initialize range sliders with step validation
      this.$nextTick(() => {
        // Validate initial values
        this.validateAmount()
        this.validatePeriods()

        // Initialize Swiper if needed
        if (window.Swiper && document.querySelector('.sliderSwiper')) {
          new window.Swiper('.sliderSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
              el: '.sliderSwiper__pagination',
              clickable: true
            },
            navigation: {
              nextEl: '.sliderSwiper__next',
              prevEl: '.sliderSwiper__prev'
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.staking-calculator-col {
  margin-bottom: 8px;
}

.staking-promo-col {
  margin-top: 0;
}

.staking-step-overview :deep(.staking-small-banner-section) {
  margin-bottom: 0;
}

.staking-step-overview :deep(.staking-small-banner-section .container) {
  max-width: none;
  padding-right: 0;
  padding-left: 0;
}

.staking-step-overview :deep(.staking-small-banner-section .row) {
  margin-right: 0;
  margin-left: 0;
}

.staking-step-overview :deep(.staking-small-banner-section .staking-small-banner) {
  overflow: hidden;
}

.deposit-contract-scroll {
  max-height: 320px;
  overflow-y: auto;
  padding-inline-end: 8px;
}

@media (max-width: 767.98px) {
  .AZ-banner--staking-section :deep(.banner-box:not(.banner-box-timer)::after) {
    padding-bottom: 52%;
  }
}

</style>
